const validateUserAccount = async (queryParams = '') => {
  try {
    let validationURL;
    switch (DEPLOYMENT_TARGET) {
      case 'prod':
        validationURL = 'https://uservalidation.cloudone.trendmicro.com/validation';
        break;
      case 'stage':
        validationURL = 'https://uservalidation.staging-cloudone.trendmicro.com/validation';
        break;
      case 'drsim':
        validationURL = 'https://uservalidation.drsim-cloudone.trendmicro.com/validation';
        break;
      case 'govcloud-prod':
        validationURL = `https://uservalidation.cloudonegov.trendmicro.com/validation`;
        break;
      case 'govcloud-staging':
        validationURL = `https://uservalidation.staging-cloudonegov.trendmicro.com/validation`;
        break;
      case 'alpha':
      case 'dev':
        validationURL =
          window.location.hostname === 'localhost'
            ? '/validation'
            : 'https://uservalidation.dev-cloudone.trendmicro.com/validation';
        break;
      default:
        validationURL = null;
    }

    const validationConfirmation = await fetch(`${validationURL}${queryParams}`, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
      headers: { 'api-version': 'v1' },
    });

    if (validationConfirmation.status === 200) {
      const userIsValidated = await validationConfirmation.json();
      history.replaceState(null, '', location.href.split('?')[0]);
      return userIsValidated;
    } else {
      const error = `Error status: ${validationConfirmation.status} - ${validationConfirmation.statusText}`;
      console.error(error);
    }
  } catch (e) {
    const errorMsg = `Error fetching services: ${e}`;
    console.log(errorMsg);
  }
};

export default validateUserAccount;
